/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { AppointmentRequestVariantId } from './AppointmentRequestVariantId';
import {
    AppointmentRequestVariantIdFromJSON,
    AppointmentRequestVariantIdFromJSONTyped,
    AppointmentRequestVariantIdToJSON,
    AppointmentRequestVariantIdToJSONTyped,
} from './AppointmentRequestVariantId';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface AppointmentRequest
 */
export interface AppointmentRequest {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof AppointmentRequest
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentRequest
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentRequest
     */
    endTime: Date;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof AppointmentRequest
     */
    variantId?: AppointmentRequestVariantId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof AppointmentRequest
     */
    locationId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentRequest
     */
    instructorNotes?: string | null;
}

/**
 * Check if a given object implements the AppointmentRequest interface.
 */
export function instanceOfAppointmentRequest(value: object): value is AppointmentRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function AppointmentRequestFromJSON(json: any): AppointmentRequest {
    return AppointmentRequestFromJSONTyped(json, false);
}

export function AppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'variantId': json['variantId'] == null ? undefined : AppointmentRequestVariantIdFromJSON(json['variantId']),
        'locationId': json['locationId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'instructorNotes': json['instructorNotes'] == null ? undefined : json['instructorNotes'],
    };
}

export function AppointmentRequestToJSON(json: any): AppointmentRequest {
    return AppointmentRequestToJSONTyped(json, false);
}

export function AppointmentRequestToJSONTyped(value?: AppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'].toISOString(),
        'variantId': AppointmentRequestVariantIdToJSON(value['variantId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'instructorNotes': value['instructorNotes'],
    };
}

